import React, { useState, useEffect } from "react";
import {
  TablePagination,
  tablePaginationClasses as classes,
} from "@mui/base/TablePagination";
import { styled } from "@mui/system";
import { Link } from "react-router-dom";
import "./common.css";
import {
  AiTwotoneDelete,
  AiTwotoneEdit,
  AiTwotoneEye,
  AiOutlinePlusCircle,
} from "react-icons/ai";
import API_URL from "../common/Apiurl";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import SuccessMessage from "../common/Message";
import SearchBar from "material-ui-search-bar";
import ExportExcel from "../excelsheet/Excelexport";

function Category() {
  // new table
  const apiUrl = API_URL;
  const [items, setItems] = useState([]);
  const [csvitems, setCsvitems] = useState([]);
  const [alldata, setAlldata] = useState([]);
  const [open, setOpen] = React.useState(false);
  const [deleteconfirm, setDeleteconfirm] = useState("");
  const [successMessages, setSuccessMessages] = useState([]);
  const [searched, setSearched] = useState("");
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [industryValue, setIndustryValue] = useState([]);
  const getData = localStorage.getItem("user-info");
  const accessbility = JSON.parse(getData).data.accessbility;

  const handleOpen = (e, id) => {
    setOpen(true);
    setDeleteconfirm(id);
  };
  const handleClose = () => setOpen(false);
  const category_list = async () => {
    const res = await fetch(`${apiUrl}/admin/categorylist`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
    const data = await res.json();
    if (data.status !== 200) {
      throw new Error("Data not found");
    }
    setItems(data.data);
    setCsvitems(data.csvdata);
    setAlldata(data.data);
    setIndustryValue(data.industrylist);
  };
  const filterbyindustry = async (industryId) => {
    const postindustry = {
      ind_id: industryId,
    };
    const filterind = await fetch(`${apiUrl}/admin/filterbyindustry`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(postindustry),
    });
    const filtereddata = await filterind.json();
    if (filtereddata.status === 200) {
      setItems(filtereddata.data);
      localStorage.setItem("industryFilterCategory", industryId);
    }
  };
  useEffect(() => {
    const getComments = async () => {
      try {
        if (
          localStorage.getItem("industryFilterCategory") !== null &&
          localStorage.getItem("industryFilterCategory") !== ""
        ) {
          console.log("simran");
          const industryId = localStorage.getItem("industryFilterCategory");
          filterbyindustry(industryId);
        } else {
          category_list();
        }
      } catch (error) {
        console.error("Error ", error);
      }
    };
    getComments();
  }, []);
  // get industry

  const deletecategory = async (e, id) => {
    e.preventDefault();
    setOpen(false);
    try {
      const posttodeleteData = {
        id: id,
      };
      const resultdelete = await fetch(`${apiUrl}/deletecategory `, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(posttodeleteData),
      });
      const deleteddata = await resultdelete.json();
      const newSuccessMessage = deleteddata.message;
      setSuccessMessages([...successMessages, newSuccessMessage]);
      if (deleteddata.status !== 200) {
        throw new Error("Data not found");
      }
    } catch (error) {
      console.log("Error: ", error);
    }
    // console.log(id);
  };
  const handleSuccessMessageFadeOut = () => {
    setSuccessMessages((prevMessages) => prevMessages.slice(1));
    window.location.reload();
  };
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 495,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };

  // new added
  var rows = items.sort((a, b) => (a.category_name < b.flag ? -1 : 1));
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const requestSearch = (searchedVal) => {
    var rows = alldata;
    const filteredRows = rows.filter((row) => {
      return row.category_name
        .toLowerCase()
        .includes(searchedVal.toLowerCase());
    });
    setItems(filteredRows);
  };
  rows = items.sort((a, b) => (a.category_name < b.flag ? -1 : 1));

  const cancelSearch = () => {
    setSearched("");
    requestSearch(searched);
    const allRows = alldata;
    setItems(allRows);
  };
  rows = items.sort((a, b) => (a.category_name < b.flag ? -1 : 1));
  // new added

  const getindustry = async (e) => {
    const industryId = e.target.value;
    filterbyindustry(industryId);
  };

  const newArray = [];
  const itemsValue = csvitems;
  itemsValue.map((dataItem, index) => {
    const newItem = {
      Number: index + 1,
      CategoryName: dataItem.Categoryname,
      IndustryName: dataItem.Industryname,
      Keywords: dataItem.keywords,
    };
    newArray.push(newItem);
  });
  const ExcelExportData = newArray;
  const clearData = async () => {
    localStorage.setItem("industryFilterCategory", "");
    category_list();
  };
  return (
    <div className="width90">
      <div className="row">
        <div className="col-sm-6">
          <h2 className="pageTitle">Category List</h2>
        </div>
        {accessbility?.category.write === 1 ||
        accessbility?.category.write === true ? (
          <div className="col-sm-6">
            <Link to="/admin/category/addcategory">
              <button
                type="button"
                className="btn btn-primary float-right addBtn"
              >
                <span className="btn">
                  <AiOutlinePlusCircle />
                </span>{" "}
                Add Category
              </button>
            </Link>
          </div>
        ) : null}
      </div>
      <SearchBar
        value={searched}
        onChange={(searchVal) => requestSearch(searchVal)}
        onCancelSearch={() => cancelSearch()}
        className="mt-4"
      />
      {/* excelsheet */}
      <div className="form-group mt-3">
        <div className="row">
          <div className="col-sm-4">
            <label
              className="control-label col-sm-10 label"
              htmlFor="industrytype"
            >
              Select Industry to filter category:
            </label>
            <select
              className="form-select col-sm-5 selectBox"
              onChange={getindustry}
              value={localStorage.getItem("industryFilterCategory")}
            >
              <option value="">Select Industry</option>
              {industryValue.map((inditems) => {
                return (
                  <option value={inditems.id}>{inditems.industry_name}</option>
                );
              })}
            </select>
          </div>
          <div className="col-sm-2">
            <label
              className="control-label col-sm-10 label"
              htmlFor="exportData"
            >
              Clear the filter to get all data
            </label>
            <button onClick={clearData}>Clear all filter</button>
          </div>
          <div className="col-sm-5 text-end">
            <label
              className="control-label col-sm-10 label"
              htmlFor="exportData"
            >
              Export Data
            </label>
            <ExportExcel excelData={ExcelExportData} fileName={"Category"} />
          </div>
        </div>
      </div>
      {/* excelsheet */}
      {/* root */}
      <Root sx={{ maxWidth: "100%", width: 500 }}>
        <table aria-label="custom pagination table" className="cntr">
          <thead>
            <tr>
              <th>S.No.</th>
              <th>Category Name</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {(rowsPerPage > 0
              ? rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              : rows
            ).map((row, index) => (
              // <tr key={row.category_name}>
              <tr>
                <td>{index + 1}</td>
                <td>{row.category_name}</td>
                <td style={{}} align="right">
                  {accessbility?.category.read === 1 ||
                  accessbility?.category.read === true ? (
                    <Link
                      to={`/admin/category/viewcategory/${row.id}`}
                      className="view"
                    >
                      <AiTwotoneEye />
                    </Link>
                  ) : null}
                  {accessbility?.category.write === 1 ||
                  accessbility?.category.write === true ? (
                    <Link
                      to={`/admin/category/editcategory/${row.id}`}
                      className="edit"
                    >
                      <AiTwotoneEdit />
                    </Link>
                  ) : null}
                  {accessbility?.category.write === 1 ||
                  accessbility?.category.write === true ? (
                    <button
                      type="button"
                      className="delete"
                      onClick={(e) => handleOpen(e, row.id)}
                    >
                      <AiTwotoneDelete />
                    </button>
                  ) : null}
                </td>
              </tr>
            ))}
            {emptyRows > 0 && (
              <tr style={{ height: 41 * emptyRows }}>
                <td colSpan={3} aria-hidden />
              </tr>
            )}
          </tbody>
          <tfoot>
            <tr>
              <CustomTablePagination
                rowsPerPageOptions={[5, 10, 25, { label: "All", value: -1 }]}
                colSpan={3}
                count={rows.length}
                rowsPerPage={rowsPerPage}
                page={page}
                slotProps={{
                  select: {
                    "aria-label": "rows per page",
                  },
                  actions: {
                    showFirstButton: true,
                    showLastButton: true,
                  },
                }}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </tr>
          </tfoot>
        </table>
      </Root>
      {/* root */}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Are you sure you want to delete this category?
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            <Button
              variant="contained"
              onClick={(e) => deletecategory(e, deleteconfirm)}
            >
              OK
            </Button>
            <Button
              variant="contained"
              onClick={handleClose}
              className="cancelbtn"
            >
              Cancel
            </Button>
          </Typography>
        </Box>
      </Modal>
      {/*  */}
      {successMessages.map((message, index) => (
        <SuccessMessage
          key={index}
          message={message}
          onFadeOut={handleSuccessMessageFadeOut}
        />
      ))}
    </div>
  );
}

const grey = {
  200: "#d0d7de",
  800: "#32383f",
  900: "#24292f",
};

const Root = styled("div")(
  ({ theme }) => `
  table {
    font-family: IBM Plex Sans, sans-serif;
    font-size: 0.875rem;
    border-collapse: collapse;
    width: 100%;
  }

  td,
  th {
    border: 1px solid ${theme.palette.mode === "dark" ? grey[800] : grey[200]};
    text-align: left;
    padding: 8px;
  }

  th {
    background-color: ${theme.palette.mode === "dark" ? grey[900] : "#fff"};
  }
  `
);

const CustomTablePagination = styled(TablePagination)`
  & .${classes.toolbar} {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;

    @media (min-width: 768px) {
      flex-direction: row;
      align-items: center;
    }
  }

  & .${classes.selectLabel} {
    margin: 0;
  }

  & .${classes.displayedRows} {
    margin: 0;

    @media (min-width: 768px) {
      margin-left: auto;
    }
  }

  & .${classes.spacer} {
    display: none;
  }

  & .${classes.actions} {
    display: flex;
    gap: 0.25rem;
  }
`;

export default Category;
